import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/store/reducers";
import { LoadActiveSpecialAccessUsernames } from "src/services/Maintenance/SpecialAccessUserService";

const SpecialAccessLoader = () => {
  const dispatch = useDispatch();
  const logged = useSelector((state: RootState) => state.auth.logged);

  useEffect(() => {
    if (logged) {
      LoadActiveSpecialAccessUsernames(dispatch);
    }
  }, [dispatch, logged]);

  return null;
};

export default SpecialAccessLoader;
